// The marquee's CSS loops a track by shifting it -50% of its own width —
// seamless only when the track holds an even number of identical copies
// whose combined width covers at least the visible bar twice over.
// Liquid renders just one copy; this measures it against the actual bar
// width and clones enough more to satisfy that, then scales the animation
// duration so playback speed (pixels/second) stays constant regardless of
// how many copies ended up needed.
(function () {
  var BASE_SECONDS_PER_PAIR = 22;

  function layout(bar) {
    var track = bar.querySelector('[data-flix-announce-track]');
    var groups = track.querySelectorAll('[data-flix-announce-group]');
    if (!track || !groups.length) return;

    // Re-running (e.g. on resize) needs a clean single copy to measure from,
    // not yesterday's clone count layered on top of a new viewport width.
    for (var i = 1; i < groups.length; i++) groups[i].remove();
    var group = track.querySelector('[data-flix-announce-group]');

    var groupWidth = group.getBoundingClientRect().width;
    var barWidth = bar.getBoundingClientRect().width;
    if (!groupWidth || !barWidth) return;

    var copies = Math.max(2, Math.ceil((barWidth * 2) / groupWidth));
    if (copies % 2 !== 0) copies += 1;
    for (var c = 1; c < copies; c++) track.appendChild(group.cloneNode(true));

    var pairs = copies / 2;
    track.style.animationDuration = (pairs * BASE_SECONDS_PER_PAIR) + 's';
  }

  function init() {
    document.querySelectorAll('[data-flix-announce-bar]').forEach(layout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 200);
  });
})();
